import {retryAccreditation as postRetryAccreditation} from '@/accreditation/accreditationApi.js';

export const ACCREDITATION_LOAD_FORCATALOGITEM = 'ACCREDITATION_LOAD_FORCATALOGITEM';
export const ACCREDITATION_LOAD_FORUSER = 'ACCREDITATION_LOAD_FORUSER';
export const ACCREDITATION_RETRY = 'ACCREDITATION_RETRY';

const PAGESIZE = 30;

export const loadAccreditationsForCatalogItem = (catalogItem) => async (dispatch, getState) => {
    const {oidc, minervaSettings, accreditation} = getState();
    const {portalIdentifier, apiUrl} = minervaSettings;
    const {targetId} = catalogItem;

    const pageIndex = targetId === accreditation.targetId ? accreditation.pageIndex + 1 : 0;

    dispatch({
        type: ACCREDITATION_LOAD_FORCATALOGITEM,
        async payload() {
            const params = new URLSearchParams({
                pageIndex: pageIndex,
                pageSize: PAGESIZE,
            });

            const res = await fetch(
                `${apiUrl}/api/1.0/accreditations/catalogitem/${portalIdentifier}/${targetId}?${params}`,
                {
                    headers: getAuthorizationHeaders(oidc.user),
                },
            );

            const response = await res.json();

            return {
                targetId: targetId,
                list: response.results,
                pageIndex: pageIndex,
                total: response.count,
            };
        },
    });
};

// Sends an accreditation PE-online did not accept again; the row gets the new result. A refusal of
// the Learning API rejects with an AccreditationRetryError whose `reason` the reducer keeps.
export const retryAccreditation = (accreditation) => async (dispatch) => {
    // The promise middleware rethrows a rejected payload after dispatching _REJECTED; the reducer
    // has the error by then, so it is not an unhandled rejection here.
    await dispatch({
        type: ACCREDITATION_RETRY,
        meta: {id: accreditation.id},
        payload: postRetryAccreditation(accreditation),
    }).catch(() => {});
};

export const loadAccreditationsForUser = (idString) => async (dispatch, getState) => {
    const {oidc, minervaSettings, accreditation} = getState();
    const {portalIdentifier, apiUrl} = minervaSettings;

    const pageIndex = idString === accreditation.idString ? accreditation.pageIndex + 1 : 0;

    dispatch({
        type: ACCREDITATION_LOAD_FORUSER,
        async payload() {
            const params = new URLSearchParams({
                pageIndex: pageIndex,
                pageSize: PAGESIZE,
            });

            const res = await fetch(
                `${apiUrl}/api/1.0/accreditations/${portalIdentifier}/${toBase64Url(idString)}?${params}`,
                {
                    headers: getAuthorizationHeaders(oidc.user),
                },
            );

            const response = await res.json();

            return {
                idString: idString,
                list: response.results,
                pageIndex: pageIndex,
                total: response.count,
            };
        },
    });
};

// An idString can contain slashes, so it travels base64url-encoded in the path.
const toBase64Url = (value) =>
    btoa(String.fromCodePoint(...new window.TextEncoder().encode(value)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');

const getAuthorizationHeaders = (user) => {
    return user ? {Authorization: `Bearer ${user.access_token}`} : {};
};
